<template>
  <v-card>
    <v-card-title>
      Admins
    </v-card-title>
    <v-card-text>
      <v-list-item
        v-for="(person, i) in list"
        :key="i"
      >
        <v-list-item-content>
          <v-list-item-title>
            {{ person.name }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'AdminList',
  props: {
    list: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
